import { render, staticRenderFns } from "./chateau-levangile.vue?vue&type=template&id=4b39952b&scoped=true"
import script from "./chateau-levangile.vue?vue&type=script&lang=js"
export * from "./chateau-levangile.vue?vue&type=script&lang=js"
import style0 from "./chateau-levangile.vue?vue&type=style&index=0&id=4b39952b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b39952b",
  null
  
)

export default component.exports